package com.patronat.top.core.domain.usecase.command.auth

import com.patronat.top.domain.usecase.Command
import com.patronat.top.dto.AuthFlow


data class ConfirmEmailCommand(val email: String, val code: String, val flow: AuthFlow) : Command